import React, { useState } from 'react';
import { useClub } from '../hooks/useClub';

// Phone + email on every pipeline card, plus a "find in PlayByPoint" shortcut
// (team feedback, 10/5/26: "all pipelines and all stage cards need both the phone
// number and email ... and a link to the member's PbP profile").
//
// The PbP profile link is NOT a real deep link: PlayByPoint's admin addresses a
// player by an internal numeric id that the API doesn't expose (checked 10/5/26:
// Customer.member_number is empty, membership ids are opaque, and the API customer
// UUID 404s on /profiles/{uuid}). So the button does the next best thing: it
// copies the person's email (or phone, or name) and opens the club's All Players
// report — a read-only page covering members AND non-members — where one paste into
// its search box finds them. Replace with a real link if PbP ever exposes the id
// (asked of PbP; see CLAUDE.md).
const PBP_SLUG_BY_CLUB = {
  DEN: 'thepicklrdenton',
  LEW: 'thepicklrlewisville',
  MCK: 'thepicklrmckinney',
  GB: 'thepicklrgreenbay',
  MF: 'thepicklrmenomonee-falls',
  WA: 'thepicklrwestallis',
};

const stop = e => e.stopPropagation(); // cards are clickable — don't open the outcome modal

export default function ContactLines({ phone, email, name, clubId, size = 'sm', style, compact = false }) {
  const { currentClub } = useClub();
  const [copied, setCopied] = useState(false);
  const club = clubId || currentClub?.id;
  const slug = PBP_SLUG_BY_CLUB[club];
  const cleanEmail = email && !String(email).startsWith('—') ? email : null;
  const cleanPhone = phone && !String(phone).startsWith('—') ? phone : null;
  const fs = size === 'xs' ? 9.5 : 10.5;

  function findInPbp(e) {
    e.stopPropagation();
    const term = cleanEmail || cleanPhone || name || '';
    const open = () => {
      if (slug) window.open(`https://app.playbypoint.com/admin/facilities/${slug}/manage_bookings#/executive_dashboard/reports/all_players`, '_blank', 'noopener');
    };
    if (term && navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(term).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2500); open(); }).catch(open);
    } else {
      open();
    }
  }

  if (!cleanEmail && !cleanPhone) {
    return <div style={{ fontSize: fs, color: '#666', marginBottom: 4, ...style }}>No phone or email on file</div>;
  }
  const link = { color: '#9ca3af', textDecoration: 'none' };
  return (
    <div style={{ fontSize: fs, color: '#888', marginBottom: 4, lineHeight: 1.45, ...style }}>
      {cleanPhone && (
        <div style={{ fontFamily: 'monospace' }}>
          <a href={`tel:${String(cleanPhone).replace(/[^\d+]/g, '')}`} onClick={stop} style={link}>{cleanPhone}</a>
        </div>
      )}
      {cleanEmail && (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={cleanEmail}>
          <a href={`mailto:${cleanEmail}`} onClick={stop} style={link}>{cleanEmail}</a>
        </div>
      )}
      {slug && compact && (
        <span onClick={findInPbp} title="Find in PlayByPoint: copies their email or phone, then opens the All Players report to paste into its search"
          style={{ cursor: 'pointer', color: copied ? '#22c55e' : '#60a5fa', fontSize: fs - 0.5 }}>
          {copied ? '✓ copied, paste in search' : '↗ PbP'}
        </span>
      )}
      {slug && !compact && (
        <span onClick={findInPbp} title="Copies their email/phone, then opens PlayByPoint's All Players report — paste into its search"
          style={{ cursor: 'pointer', color: copied ? '#22c55e' : '#60a5fa', fontSize: fs - 0.5 }}>
          {copied ? '✓ Copied — paste in search' : '↗ Find in PlayByPoint'}
        </span>
      )}
    </div>
  );
}
